module.exports = __webpack_public_path__ + "static/media/avatars_male_26.47547338.png";